/**
 * Wohin nach der Anmeldung — zurück, wo man war.
 *
 * Die Middleware hängt bei jeder Umleitung auf die Anmeldung ein
 * `next=/news` an. Gelesen hat es bisher niemand: `login/page.tsx` leitete
 * pauschal auf `/` weiter, und die Anmeldekarte schickte jede bestehende
 * Sitzung nach `/dashboard`. Wer beim Lesen der Nachrichten kurz die
 * Sitzung erneuern musste, landete auf der Startseite und hatte seine
 * Stelle verloren — genau die gemeldete Beobachtung.
 *
 * WARUM DAS GEPRÜFT WERDEN MUSS: ein ungeprüftes `next` ist eine offene
 * Weiterleitung. `next=https://fremde-seite.example` schickte den frisch
 * Angemeldeten dorthin — mitsamt dem Vertrauen, das er der eigenen Adresse
 * entgegenbringt. Erlaubt ist deshalb nur ein Pfad innerhalb dieser
 * Anwendung.
 */

/** Fallback, wenn kein oder kein zulässiges Ziel angegeben ist. */
export const START = '/dashboard'

export function sichererRuecksprung(next: string | null | undefined, start = START): string {
  const s = String(next || '').trim()
  if (!s) return start

  // Muss mit genau EINEM Schrägstrich beginnen. `//fremd.example` wäre für
  // den Browser eine absolute Adresse mit geerbtem Schema.
  if (!s.startsWith('/') || s.startsWith('//')) return start

  // Keine Steuerzeichen — sonst liesse sich eine Kopfzeile anhängen.
  if (/[\u0000-\u001f\u007f]/.test(s)) return start

  // Nicht zurück auf die Anmeldung selbst: das ergäbe eine Schleife.
  if (/^\/(login|auth)(\/|$|\?)/.test(s)) return start

  return s
}
